import React from 'react'
import Header2 from '../../components/shared/Header2'
import Footer2 from '../../components/shared/Footer2';
import top3 from '../../assets/new-image/new-bg.png';
import question from '../../assets/dollar.png';
import girl from '../../assets/about/girl.png';
import foldright from '../../assets/about/fold-right.png';
import foldleft from '../../assets/about/fold-left.png';

function Pricing() {
  const [pricingData, setPricing] = React.useState([
    {
      name: "Starter($999/year)",
      key_features: [
        "Publish Job Roles & Descriptions",
        "Build Tailored Competencies & Capabilities",
        "Basic Skill Fitment Assessment",
        "Advanced Skill Fitment Assessment",
        "Culture Fitment Assessment",
        "Custom Competency Frameworks",
        "Al-Powered Role Optimization & Insights"
      ],
      Assessment: 100
    },
    {
      name: "Growth($2,999/year)",
      key_features: [
        "Publish Job Roles & Descriptions",
        "Build Tailored Competencies & Capabilities",
        "Basic Skill Fitment Assessment",
        "Advanced Skill Fitment Assessment",
        "Culture Fitment Assessment",
        "Custom Competency Frameworks",
        "Al-Powered Role Optimization & Insights"
      ],
      Assessment: 500
    },
    {
      name: "Enterprise($7,999/year)",
      key_features: [
        "Publish Job Roles & Descriptions",
        "Build Tailored Competencies & Capabilities",
        "Basic Skill Fitment Assessment",
        "Advanced Skill Fitment Assessment",
        "Culture Fitment Assessment",
        "Custom Competency Frameworks",
        "Al-Powered Role Optimization & Insights"
      ],
      Assessment: 2000
    },
  ])
  return (
    <>
      <Header2 />
      <section className="bg-banner-home relative " >
        <div className='max-w-7xl lg:px-0 px-4 mx-auto'>
          <div className="flex lg:flex-row flex-col items-center justify-between gap-8 lg:py-32 py-10 lg:pb-20 pb-10">
            <div className='flex-1'>
              <h3 className='font-semibold ff-pop lg:text-4xl xl:text-[46px] leading-[1.2] mb-[18px] text-[28px] text-[#191919] lg:max-w-full text-center'>
                Empower Your Growth
              </h3>
              <p className='font-normal lg:text-lg text-center text-base tracking-[-3%] text-[#40566D] lg:max-w-[900px] mx-auto  mt-9  ff-inter'>Access powerful assessments, real-time insights, and AI-driven tools—all under one flexible pricing model. Whether you're a growing startup or a large enterprise, there's a plan designed for you.</p>
            </div>
          </div>
        </div>
        <div className='absolute lg:top-24 lg:left-20 left-2 top-2 lg:w-[126px] w-12'>
          <img src={question} alt="question-mark" width={126} height={170} />
        </div>
        <div className='absolute lg:top-16 top-3 rotate-45 lg:right-24 right-4 lg:w-12 w-9'>
          <img src={question} alt="question-mark" width={48} height={67} />
        </div>
        <div className='top-image-1 lg:block hidden w-full absolute lg:-top-1/3 left-0 z-[-1]'>
          <img src={top3} className='w-full h-auto' alt="" />
        </div>
      </section>
      <div className="bg-[#FFC727] lg:pt-16 md:pt-14 pt-10 px-4 lg:pb-8">
        <div className="max-w-[1200px] mx-auto px-2">
          <div className="pb-6">
            {/* Responsive grid with spacing and centered items */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 justify-items-center">
              {pricingData.map((plan, index) => (
                <div
                  key={index}
                  className="bg-white rounded-[10px] py-9 px-[30px] w-full max-w-[360px] flex flex-col justify-between transform transition-all duration-300 hover:scale-[1.011] hover:shadow-lg"
                >
                  <div>
                    <h3 className="my-0 ff-inter font-bold text-base sm:text-lg text-center text-[#191919]">
                      {plan.name}
                    </h3>

                    <ul className="mt-6 space-y-3 text-left">
                      {plan.key_features.map((feature, i) => (
                        <li
                          key={i}
                          className="text-[#191919] ff-inter text-sm leading-relaxed flex items-start gap-2"
                        >
                          <span className="text-green-600 mt-[2px]">✓</span>
                          <span className="text-[#626262]">{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="mt-6 text-center">
                    <p className="ff-inter font-semibold text-[#333] mb-4">
                      Includes {plan.Assessment} Assessments
                    </p>
                    <button className="bg-[#191919] text-white py-2 px-6 rounded-[8px] hover:bg-[#333] transition-all duration-300">
                      Choose Plan
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer2 />
    </>
  )
}

export default Pricing